<template>
    <article-index-page type="news"/>
</template>

<script setup lang="ts">
const {t} = useI18n();

useMeta({
	title: t('view.news.index.title'),
	description: t('view.news.index.description')
});

</script>

